import { Component, EventEmitter, Output } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { faArrowRightFromBracket, faBars } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [FontAwesomeModule, CommonModule, NgOptimizedImage, RouterModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {

  @Output() menuToggled = new EventEmitter<boolean>();

  faArrowRightFromBracket = faArrowRightFromBracket;
  faBars = faBars;

  isMenuOpen = false;
  constructor(
    public authService: AuthService,
    private router: Router
  ){}
  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
    this.menuToggled.emit(this.isMenuOpen);
  }
  logout() {
    this.authService.logout();
    this.router.navigate(['/login']);
  }
}
